import { configureStore } from '@reduxjs/toolkit';

import createRootReducer, { defaultState } from '@/redux/reducer';
import { RootState } from '@/shared/types/state';

import { PUSH_MODAL, UPDATE_MODAL } from './modals/actions';
import { modalsMiddleware } from './modals/middleware';
import { sessionMiddleware } from './session/middleware';
import { sidebarMiddleware } from './sidebar/middleware';

// Get the initial state if is available in the window object
const windowState = window.MOVEO_REDUX_STATE ?? {};

export const initializeStore = (preloadedState = {}) => {
  const initialState = { ...defaultState, ...windowState, ...preloadedState } as RootState;

  const store = configureStore({
    preloadedState: initialState,
    reducer: createRootReducer(),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: { ignoredActions: [PUSH_MODAL, UPDATE_MODAL], ignoredPaths: ['modals'] },
      }).concat(sessionMiddleware, sidebarMiddleware, modalsMiddleware),
  });

  return store;
};

const store = initializeStore();

export const getStore = () => {
  return store;
};
